export default "__VITE_ASSET__BJe4QfEq__"